/**
 * 个播与厅 PK
 * 厅与厅 PK
 */

import { hoc } from '@/lib';

import handleGamesFightSocket from './socket';
import gamesFightStore from './store';
import gamesFightUtils from './utils';
import GamesFightEntry from './fight-entry';
import PopupInvite from './popup-invite';

const showPartyVsPartyInvite = () => {
  gamesFightStore.store.setFightType('partyVsParty');
  gamesFightUtils.checkFightStatus().then(() => {
    hoc.render({ key: 'fightInviteList', stage: 'partyList' }, PopupInvite);
  });
};

const showSingleVsPartyInvite = (stage: 'starList' | 'partyList') => {
  gamesFightStore.store.setFightType('singleVsParty');
  gamesFightUtils.checkFightStatus().then(() => {
    hoc.render({ key: 'fightInviteList', stage }, PopupInvite);
  });
};

export {
  GamesFightEntry,
  showPartyVsPartyInvite,
  showSingleVsPartyInvite,
  handleGamesFightSocket,
  gamesFightStore,
  gamesFightUtils,
};
